module.exports = function (id, item) {
  document.execCommand('copy', false, document.getElementById(id).select())
  if (!item) {
    this.$toast('Succesfully copied to clipboard')
  } else {
    this.$toast(`The ${item} has been copied to the clipboard`)
  }
}
